//Payment Strategy
export const TOKEN = 'TOKEN';
export const CHECKOUT = 'CHECKOUT';
export const HYPER_PAY = 'HYPER_PAY';
export const PAYFORT = 'PAYFORT';
export const CARD = 'CARD';
export const WALLET = 'E_WALLET';
export const CASHBACK_WALLET = 'CASHBACK_WALLET';
export const APPLE_PAY = 'APPLE_PAY';
export const NONE = 'NONE';
export const STC_PAY = 'STC_PAY';
